import type { SystemConfig } from '../types';

/** Apply theme preset accent colors from system-config to :root CSS variables. */
export function applySystemTheme(config: SystemConfig | null) {
  if (!config?.theme?.presets) return;

  const presetId = config.theme.defaultPreset || 'default';
  const preset = config.theme.presets[presetId];
  if (!preset) return;

  const root = document.documentElement;
  if (preset.accent) {
    root.style.setProperty('--accent-primary', preset.accent);
  }
  if (preset.accentHover) {
    root.style.setProperty('--accent-primary-hover', preset.accentHover);
  }
}
